import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type DataJson = {
  label: string;
  headerImg: string;
  headerImgWidth: number;
  headerImgHeight: number;
  headerAlt: string;
  footerImg: string;
  footerImgWidth: number;
  footerImgHeight: number;
  footerAlt: string;
  title: string;
  copyRights: string;
  phone: string;
  url: string;
  theme: string;
  dataTheme?: string;
  helpCenterPhone: string;
  termsAgreement: string;
  favicon: string;
  trustpilotRate: string;
};

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  voyagu = 'voyagu.com';
  premiumFlights = 'premiumflights.com';

  constructor(private http: HttpClient) {}

  loadDataJson(origin: string): Observable<DataJson> {
    if (origin.includes(this.voyagu)) {
      return this.http.get<DataJson>('assets/data/voyagu.json');
    }

    if (origin.includes(this.premiumFlights)) {
      return this.http.get<DataJson>('assets/data/premiumflights.json');
    }

    return this.http.get<DataJson>('assets/data/bcc.json');
  }
}
